/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
type AggregatesListingsAnalytics_aggregatesListings$ref = any;
type AggregatesListingsBreadcrumbs_aggregatesListings$ref = any;
type AggregatesListingsFAQ_place$ref = any;
type AggregatesListingsFilters_root$ref = any;
type AggregatesListingsItems_aggregatesListings$ref = any;
type AggregatesListingsMap_aggregatesListings$ref = any;
type AggregatesListingsPageMeta_aggregatesListings$ref = any;
type AggregatesListingsPageMeta_root$ref = any;
type AggregatesListingsSEOLinks_place$ref = any;
type AggregatesListingsSEOLinks_popularSearches$ref = any;
type AggregatesListingsSimilarItems_aggregatesListings$ref = any;
type aggregatesListingAlertDialog_aggregatesListings$ref = any;
type useAggregatesListingsPlaceData_aggregatesListings$ref = any;
export type GeoJSONMultiPolygonType = "MultiPolygon";
export type LangInput = "de" | "en" | "es" | "fr" | "it";
import type { FragmentReference } from "relay-runtime";
declare export opaque type AggregatesListings_root$ref: FragmentReference;
declare export opaque type AggregatesListings_root$fragmentType: AggregatesListings_root$ref;
export type AggregatesListings_root = {|
  +aggregatesListings: ?{|
    +totalCount: number,
    +similarItems: ?$ReadOnlyArray<{|
      +id: string
    |}>,
    +searchBounds: ?{|
      +ne: {|
        +lat: number,
        +lng: number,
      |},
      +sw: {|
        +lat: number,
        +lng: number,
      |},
    |},
    +searchGeometries: ?$ReadOnlyArray<{|
      +id: string,
      +geog: ?{|
        +type: GeoJSONMultiPolygonType,
        +coordinates: $ReadOnlyArray<$ReadOnlyArray<$ReadOnlyArray<[number, number]>>>,
      |},
    |}>,
    +$fragmentRefs: AggregatesListingsAnalytics_aggregatesListings$ref & AggregatesListingsBreadcrumbs_aggregatesListings$ref & AggregatesListingsItems_aggregatesListings$ref & useAggregatesListingsPlaceData_aggregatesListings$ref & AggregatesListingsSimilarItems_aggregatesListings$ref & AggregatesListingsMap_aggregatesListings$ref & AggregatesListingsPageMeta_aggregatesListings$ref & aggregatesListingAlertDialog_aggregatesListings$ref,
  |},
  +placeBySlug?: ?{|
    +canonicalPlace: ?{|
      +slug: string,
      +lang: LangInput,
    |},
    +index: boolean,
    +indexRooms: boolean,
    +$fragmentRefs: AggregatesListingsSEOLinks_place$ref & AggregatesListingsFAQ_place$ref,
  |},
  +aggregatorCustomPagesByPlace: $ReadOnlyArray<{|
    +$fragmentRefs: AggregatesListingsSEOLinks_popularSearches$ref
  |}>,
  +country?: {|
    +$fragmentRefs: AggregatesListingsSEOLinks_place$ref & AggregatesListingsFAQ_place$ref
  |},
  +$fragmentRefs: AggregatesListingsFilters_root$ref & AggregatesListingsPageMeta_root$ref,
  +$refType: AggregatesListings_root$ref,
|};
export type AggregatesListings_root$data = AggregatesListings_root;
export type AggregatesListings_root$key = {
  +$data?: AggregatesListings_root$data,
  +$fragmentRefs: AggregatesListings_root$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "Variable",
  "name": "filters",
  "variableName": "filters"
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lat",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lng",
    "storageKey": null
  }
],
v3 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "AggregatesListingsSEOLinks_place"
},
v4 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "AggregatesListingsFAQ_place"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "filters"
    },
    {
      "kind": "RootArgument",
      "name": "includeCountry"
    },
    {
      "kind": "RootArgument",
      "name": "includePlace"
    },
    {
      "kind": "RootArgument",
      "name": "lngShort"
    },
    {
      "kind": "RootArgument",
      "name": "offerType"
    },
    {
      "kind": "RootArgument",
      "name": "page"
    },
    {
      "kind": "RootArgument",
      "name": "slug"
    },
    {
      "kind": "RootArgument",
      "name": "sortBy"
    },
    {
      "kind": "RootArgument",
      "name": "sortDirection"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "AggregatesListings_root",
  "selections": [
    {
      "alias": null,
      "args": [
        (v0/*: any*/),
        {
          "kind": "Variable",
          "name": "page",
          "variableName": "page"
        },
        {
          "kind": "Variable",
          "name": "sortBy",
          "variableName": "sortBy"
        },
        {
          "kind": "Variable",
          "name": "sortDirection",
          "variableName": "sortDirection"
        }
      ],
      "concreteType": "AggregatesListingConnectionConnection",
      "kind": "LinkedField",
      "name": "aggregatesListings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AggregatesListing",
          "kind": "LinkedField",
          "name": "similarItems",
          "plural": true,
          "selections": [
            (v1/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GeoBounds",
          "kind": "LinkedField",
          "name": "searchBounds",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GeoLatLng",
              "kind": "LinkedField",
              "name": "ne",
              "plural": false,
              "selections": (v2/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "GeoLatLng",
              "kind": "LinkedField",
              "name": "sw",
              "plural": false,
              "selections": (v2/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AggregatesListingsGeoType",
          "kind": "LinkedField",
          "name": "searchGeometries",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "GeoJSONMultiPolygon",
              "kind": "LinkedField",
              "name": "geog",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "coordinates",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AggregatesListingsAnalytics_aggregatesListings"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AggregatesListingsBreadcrumbs_aggregatesListings"
        },
        {
          "args": [
            (v0/*: any*/)
          ],
          "kind": "FragmentSpread",
          "name": "AggregatesListingsItems_aggregatesListings"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useAggregatesListingsPlaceData_aggregatesListings"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AggregatesListingsSimilarItems_aggregatesListings"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AggregatesListingsMap_aggregatesListings"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AggregatesListingsPageMeta_aggregatesListings"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "aggregatesListingAlertDialog_aggregatesListings"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "language",
          "variableName": "lngShort"
        },
        {
          "kind": "Variable",
          "name": "offerType",
          "variableName": "offerType"
        },
        {
          "kind": "Variable",
          "name": "placeSlug",
          "variableName": "slug"
        }
      ],
      "concreteType": "AggregatorCustomPage",
      "kind": "LinkedField",
      "name": "aggregatorCustomPagesByPlace",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AggregatesListingsSEOLinks_popularSearches"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AggregatesListingsFilters_root"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AggregatesListingsPageMeta_root"
    },
    {
      "condition": "includePlace",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "lang",
              "variableName": "lngShort"
            },
            {
              "kind": "Variable",
              "name": "slug",
              "variableName": "slug"
            }
          ],
          "concreteType": "Place",
          "kind": "LinkedField",
          "name": "placeBySlug",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Place",
              "kind": "LinkedField",
              "name": "canonicalPlace",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "slug",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lang",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "index",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "indexRooms",
              "storageKey": null
            },
            (v3/*: any*/),
            (v4/*: any*/)
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "includeCountry",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Place",
          "kind": "LinkedField",
          "name": "country",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            (v4/*: any*/)
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '3fca028ce60f3cc0560f145db4701c22';

export default node;
